import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type { LoanRequestPayload, TopUpLoanResponse } from './types';

const topUpLoanRequest = async (
  payload: LoanRequestPayload
): Promise<TopUpLoanResponse> => {
  const res = await axios<
    TopUpLoanResponse,
    BaseResponse<TopUpLoanResponse>,
    LoanRequestPayload
  >({
    url: `/glfh/top-up/submission-of-loan-request`,
    method: 'post',
    data: {
      ...payload,
    },
  });

  return res?.data?.data;
};

export const useTopUpLoanRequest = () => {
  const { mutateAsync, data, isLoading, error } = useMutation(topUpLoanRequest);

  useEffect(() => {
    displayError(error);
  }, [error]);

  return { topUpLoanRequest: mutateAsync, data, isLoading };
};
